const HANDOFF_USER_KEY = 'he.accounts.handoffUserId';
const HANDOFF_COMPANY_KEY = 'he.accounts.handoffCompanyId';

export function setHandoffOrganization(
  userId: string,
  companyId: string
): void {
  const uid = userId?.trim();
  const cid = companyId?.trim();
  if (!uid || !cid || typeof sessionStorage === 'undefined') {
    return;
  }
  try {
    sessionStorage.setItem(HANDOFF_USER_KEY, uid);
    sessionStorage.setItem(HANDOFF_COMPANY_KEY, cid);
  } catch {
    /* ignore quota / private mode */
  }
}

export function getHandoffOrganization(): {
  userId: string;
  companyId: string;
} | null {
  if (typeof sessionStorage === 'undefined') {
    return null;
  }
  try {
    const userId = sessionStorage.getItem(HANDOFF_USER_KEY)?.trim() || '';
    const companyId = sessionStorage.getItem(HANDOFF_COMPANY_KEY)?.trim() || '';
    if (!userId || !companyId) {
      return null;
    }
    return { userId, companyId };
  } catch {
    return null;
  }
}

export function clearHandoffOrganization(): void {
  if (typeof sessionStorage === 'undefined') {
    return;
  }
  try {
    sessionStorage.removeItem(HANDOFF_USER_KEY);
    sessionStorage.removeItem(HANDOFF_COMPANY_KEY);
  } catch {
    /* ignore */
  }
}

export function resolveActiveOrganizationId(): string | null {
  return getHandoffOrganization()?.companyId ?? null;
}
